export const useHelpers = () => {
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const getBodyBuyingSellingDollars = (FormScreen, user) => {
        
        return {
            idgestion: FormScreen.formState.idgestion,
            idgestiontipo: FormScreen.formState.idgestiontipo,
            idcaja: FormScreen.formState.idcaja,
            idusuario: user.uid,
            monto_solicitado: FormScreen.formState.monto_solicitado,
            tipo_cambio: FormScreen.formState.tipo_cambio,
            monto_convertido: FormScreen.formState.monto_convertido,
            idcaja_destino: FormScreen.formState.idcaja_destino,
            descripcion: FormScreen.formState.descripcion,
            user: user.username,
            aprobacion_check: 'Aprobado'
        }
    }

    
    return Object.freeze({
        getCurrentDate,
        getBodyBuyingSellingDollars
    })
}